import { ReservationService } from "./../services/reservation-service/reservation.service";
import { environment } from "./../../environments/environment";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../services/payment/payment.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProjectsService } from "../services/projects/projects.service";
import "rxjs/add/observable/of";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import swal from "sweetalert2";

@Component({
  selector: "app-contract-generate",
  templateUrl: "./contract-generate.component.html",
  styleUrls: ["./contract-generate.component.css"],
})
export class ContractGenerateComponent implements OnInit {
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  reservation_id: any;
  contract_template_id = "";
  unit_purpose_id = "";
  project_id: any;

  is_loading: boolean = false;

  contractForm = [];

  sharing_leads: any;
  types: any = ["National ID", "Passport"];
  contractsTemplates = [];

  contracts: any;
  constructor(
    private http: HttpClient,
    private paymentService: PaymentService,
    private projectsService: ProjectsService,
    private fb: FormBuilder,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private reservationService: ReservationService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.reservation_id = +params["id"] || 0;
      this.project_id = +params["project_id"];
      this.fetchReservation();
    });
    this.reservationService
      .getContractsTemplates(this.project_id)
      .subscribe((data: any) => {
        this.contractsTemplates = data;
      });
  }

  ngOnInit() {
    this.getUnitPurposes();
  }

  unitPurposes: any;
  getUnitPurposes() {
    this.reservationService.getUnitPurposes().subscribe((data: any) => {
      this.unitPurposes = data;
    });
  }

  fetchReservation() {
    this.reservationService.getSingleReservation(this.reservation_id).subscribe(
      (data: any) => {
        this.sharing_leads = data.data[0].sharing_leads;
        this.createForm();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  createForm() {
    console.log(this.sharing_leads);
    this.sharing_leads.map((lead) => {
      this.contractForm.push({
        client_name_ar: lead.lead_name,
        client_address_ar: lead.lead_address,
        client_nationality_ar: lead.lead_nationality,
        client_phone: lead.lead_phone,
        client_phone_2: "",
        client_phone_3: "",
        client_email: lead.lead_email,
        client_nationality_id: lead.lead_national_id,
        client_mailing_address_ar: "",
        client_issue_date: "",
        client_national_serial: lead.lead_national_serial,
        client_national_office: lead.lead_national_office,
        client_correspondence_address_egypt: "",
        client_representative_name: "",
        client_power_of_attorney_number: "",
        client_power_of_attorney_year: "",
        client_notary_office: "",
        client_power_of_attorney_issue_date: "",
        client_representative_id_number: "",
        client_representative_id_issuing_authority: "",
        client_representative_governorate: "",
        client_representative_id_issue_date: "",
        client_representative_id_serial_number: "",
        client_representative_address: "",
        client_representative_district: "",
        client_power_of_attorney_governorate: "",
        lead_id: lead.lead_id,
        include_customer: true,
      });
    });
  }

  generateContract() {
    let data = {
      reservation_id: this.reservation_id,
      clients: this.contractForm.filter(
        (customer) => customer.include_customer
      ),
      contract_template_id: this.contract_template_id,
      unit_purpose_id: this.unit_purpose_id,
    };
    this.is_loading = true;
    this.reservationService.generateContract(data).subscribe(
      (res: any) => {
        swal("Success!", "", "success");
        this.contractForm = [];
        this.createForm();
        this.contracts = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => (this.is_loading = false)
    );
  }

  openContract(url) {
    window.open(url);
  }

  getArabicNumber(num: number): string {
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return num.toString().split('').map(digit => arabicNumbers[parseInt(digit)]).join('');
  }

  addCustomer() {
    if (this.contractForm.length < 4) {
      this.contractForm.push({
        client_name_ar: '',
        client_address_ar: '',
        client_nationality_ar: '',
        client_phone: '',
        client_phone_2: '',
        client_phone_3: '',
        client_email: '',
        client_nationality_id: '',
        client_mailing_address_ar: '',
        client_issue_date: '',
        client_national_serial: '',
        client_national_office: '',
        client_correspondence_address_egypt: '',
        client_representative_name: '',
        client_power_of_attorney_number: '',
        client_power_of_attorney_year: '',
        client_notary_office: '',
        client_power_of_attorney_issue_date: '',
        client_representative_id_number: '',
        client_representative_id_issuing_authority: '',
        client_representative_governorate: '',
        client_representative_id_issue_date: '',
        client_representative_id_serial_number: '',
        client_representative_address: '',
        client_representative_district: '',
        client_power_of_attorney_governorate: '',
        lead_id: null,
        include_customer: true,
      });
    }
  }

  removeCustomer(index: number) {
    if (this.contractForm.length > 1) {
      this.contractForm.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/contract-generate/contract-generate.component.ts